/**
 * External Dependencies
 */
import 'jquery';

jQuery(function () {
  function setCookie(name, value, days) {
    var d = new Date();
    d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
    document.cookie = name + '=' + value + ';path=/;expires=' + d.toGMTString();
  }

  function getCookie(name) {
    var v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
    return v ? v[2] : null;
  }

  function resetAccessibilitySettings(params) {
    var i = 0;
    for (i = 0; i < params.length; i++) {
      document.body.classList.remove(params[i]);
      document.cookie =
        params[i] + '= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
    }
    $('body').css('font-size', 16);
  }

  //reading line functionality
  var readingLine = document.getElementById('reading-line');
  window.addEventListener('mousemove', function (event) {
    if (document.body.classList.contains('reading-line')) {
      var top = event.pageY + 2 + 'px';
      readingLine.style.top = top;
    }
  });

  //ACCESSIBILITY PANEL
  document.addEventListener('click', function (event) {
    //accessibility-panel button clicks
    if (!event.target.closest('.accessibility-panel-buttons .cta-button'))
      return;

    var dataAccessibility = event.target.getAttribute('data-accessibility');
    if (dataAccessibility != null) {
      if (dataAccessibility != 'reset-accessibility-settings') {
        document.body.classList.toggle(dataAccessibility);

        //set/delete cookie on click
        var accessibilityCookie = getCookie(dataAccessibility);
        if (accessibilityCookie == null) {
          setCookie(dataAccessibility, 'true', 365);
        } else {
          document.cookie =
            dataAccessibility + '= ; expires = Thu, 01 Jan 1970 00:00:00 GMT';
        }

        if (event.target.classList.contains('toggle-reading-line')) {
          var currentCursorPos = event.clientY + 2 + 'px';
          readingLine.style.top = currentCursorPos;
        }
      } else {
        //reset all setting cookies
        var accessibilitySettings = [
          'high-contrast',
          'night-mode',
          'text-big',
          'text-small',
          'reading-line',
        ];
        resetAccessibilitySettings(accessibilitySettings);
      }
    }

    var maxFontsize = 24;
    var minFontsize = 16;
    if (event.target.classList.contains('increase-text')) {
      var fontsize = parseInt($('body').css('font-size'));
      if (fontsize < maxFontsize) {
        $('body').css('font-size', fontsize + 2);
      }
    } else if (event.target.classList.contains('decrease-text')) {
      var fontsize = parseInt($('body').css('font-size'));
      if (fontsize > minFontsize) {
        $('body').css('font-size', fontsize - 2);
      }
    }
  });

  //accessibility-panel toggle
  var toggleAccessibilityPanel = document.querySelector(
    '.toggle-accessibility-panel'
  );
  var toggleHighContrast = document.querySelector('.toggle-high-contrast');
  toggleAccessibilityPanel.addEventListener('click', (e) => {
    $('.accessibility-panel').slideToggle();
    toggleAccessibilityPanel.classList.toggle('active');
    if (!$(this).hasClass('active')) {
      toggleHighContrast.focus();
    }
  });

  //close panel by focus out
  // document.querySelector('.reset-accessibility-settings').addEventListener('focusout', (e) => {
  //   $('.accessibility-panel').slideToggle();
  //   document.querySelector('.toggle-accessibility-panel').classList.toggle('active');
  // });

  //submenu flyout, parent not linked (country menu)
  let menuItems = document.querySelectorAll('.nav > .menu-item-has-children');
  Array.prototype.forEach.call(menuItems, function (menuItem) {
    menuItem.querySelector('a').setAttribute('href', '!#');
    menuItem.querySelector('a').addEventListener('click', function (event) {
      event.preventDefault();
      return false;
    });
    menuItem.addEventListener('click', function () {
      if (this.classList.contains('open')) {
        this.classList.remove(
          'open',
          'outside-viewport-right',
          'outside-viewport-left'
        );
      } else {
        menuItem.classList.remove(
          'open',
          'outside-viewport-right',
          'outside-viewport-left'
        );
        Array.prototype.forEach.call(menuItems, function (element) {
          element.classList.remove(
            'open',
            'outside-viewport-right',
            'outside-viewport-left'
          );
        });
        this.classList.add('open');
      }

      /* main menu positioning depending on viewport width */
      var windowWidth = $(window).width() - 40;
      var rightPos =
        $(this).find('.sub-menu').offset().left +
        $(this).find('.sub-menu').width();
      var leftPos = $(this).find('.sub-menu').offset().left;

      if (rightPos > windowWidth) {
        $(this).addClass('outside-viewport-right');
      } else if (leftPos < 40) {
        $(this).addClass('outside-viewport-left');
      } else {
        $(this).removeClass('outside-viewport-right');
        $(this).removeClass('outside-viewport-left');
      }
    });
  });

  if ($('.country-nav').length) {
    const langMenu = document.querySelector('.country-nav .has-submenu');
    document
      .querySelector('.country-nav .has-submenu > a')
      .setAttribute('href', '#!');
    langMenu.addEventListener('click', function () {
      langMenu.classList.toggle('open');
    });
  }

  //sticky main header
  var scrollPosition = window.scrollY;
  var header = document.querySelector('.main-header');

  window.addEventListener('scroll', function () {
    scrollPosition = window.scrollY;

    var headerBarHeight = document.querySelector('.header-bar').offsetHeight;
    var headerHeight = header.offsetHeight;
    var accessibilityPanelHeight = document.querySelector(
      '.accessibility-panel'
    ).offsetHeight;
    var scrollHeight = headerBarHeight + accessibilityPanelHeight;
    var hasSubmenu = document.querySelector('.has-submenu');

    if (scrollPosition >= scrollHeight) {
      document.body.classList.add('scrolled');
      header.classList.add('fixed');
      if (hasSubmenu) {
        hasSubmenu.classList.remove('open');
        hasSubmenu.setAttribute('aria-expanded', 'false');
      }
    } else {
      document.body.classList.remove('scrolled');
      header.classList.remove('fixed');
    }
  });

  //main navigation
  var navFirstLevel = $('#menu-header > li > .sub-menu');
  navFirstLevel.each(function (n) {
    if (!$(this).find('.sub-menu').length > 0) {
      $(this).parent().addClass('no-flex');
    }
  });

  //off-canvas navigation
  $('.nav-mobile').hcOffcanvasNav({
    disableAt: 1024,
    customToggle: $('.toggle-menu'),
    levelTitles: true,
    levelTitleAsBack: true,
    position: 'right',
    width: 375,
    disableBody: false,
  });

  //search-toggle
  $('.toggle-search, .search-close').on('click', (e) => {
    $('.overlay-search').toggleClass('active');
    $('body').toggleClass('disable-scrolling');
    return false;
  });

  //mobile subnav toggle
  $('.toggle-subnav-mobile').on('click', (e) => {
    $('.subnav-mobile').toggleClass('open');
    return false;
  });

  //team archive scrollspy
  // Run the scrNav when scroll
  var link = $('.team-section-nav a');
  $(window).on('scroll', function () {
    scrNav();
  });
  function scrNav() {
    var sTop = $(window).scrollTop();
    $('.archive-team-department-title').each(function () {
      var id = $(this).attr('id'),
        offset = $(this).offset().top - 1,
        height = $(this).height();
      if (sTop >= offset && sTop < offset + height) {
        link.parent().removeClass('active');
        $('.team-section-nav')
          .find('[data-scroll="' + id + '"]')
          .parent()
          .addClass('active');
      }
    });
  }
  scrNav();

  //filter-select
  $('.filter-custom-select-hl').click(function () {
    var $filterParent = $(this).parent();
    $('.filter-custom-select').not($filterParent).removeClass('active');
    $(this).parent().toggleClass('active');
    return false;
  });

  $(window).on('click', (e) => {
    $('.filter-custom-select').removeClass('active');
  });

  $('.filter-custom-select').on('click', (e) => {
    e.stopPropagation();
  });

  if ($('#testamentrechner').length) {
    iframeResize(
      {
        license: '1jy4dww5qzv-s54r73oxcn-v59f4kfgfz',
        waitForLoad: true,
        log: true,
      },
      '#testamentrechner'
    );
  }
});
